import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useMemo } from "react";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Memoizar o token para evitar re-renderizações desnecessárias
  const token = useMemo(() => {
    return typeof window !== 'undefined'
      ? (localStorage.getItem('auth_token') || localStorage.getItem('token'))
      : null;
  }, []);

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  // Se há token, permitir acesso (validação completa acontece no AuthContext)
  if (token) {
    return children;
  }

  // Redirecionar para login se não estiver autenticado e não há token
  if (!isAuthenticated && !token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
